import { render, staticRenderFns } from "./AddCardWord.vue?vue&type=template&id=b9b20bcc&scoped=true&"
import script from "./AddCardWord.vue?vue&type=script&lang=js&"
export * from "./AddCardWord.vue?vue&type=script&lang=js&"
import style0 from "./AddCardWord.vue?vue&type=style&index=0&id=b9b20bcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b20bcc",
  null
  
)

export default component.exports